(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["touring"]) return;
  try {
    
  const SECTION = '[data-touring]';

  // Bandsintown only returns the abbreviation; the badge wants the full name.
  // Unmapped regions (non-US) fall back to whatever the API returned.
  const REGIONS = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California',
    CO: 'Colorado', CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia',
    FL: 'Florida', GA: 'Georgia', HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois',
    IN: 'Indiana', IA: 'Iowa', KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana',
    ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts', MI: 'Michigan',
    MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana',
    NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey',
    NM: 'New Mexico', NY: 'New York', NC: 'North Carolina', ND: 'North Dakota',
    OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania',
    RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota', TN: 'Tennessee',
    TX: 'Texas', UT: 'Utah', VT: 'Vermont', VA: 'Virginia', WA: 'Washington',
    WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming',
  };

  function formatDate(value) {
    // Bandsintown returns a naive local datetime ("2026-09-19T20:00:00").
    // Parsing it as-is would apply the viewer's timezone and can shift the day,
    // so read the calendar parts out of the string directly.
    const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value || '');
    if (!match) return '';
    const [, year, month, day] = match;
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    return date.toLocaleDateString(undefined, {
      month: 'long',
      day: '2-digit',
      year: 'numeric',
    });
  }

  function shortLocation(venue) {
    const city = venue?.city || '';
    const region = venue?.region || '';
    if (city && region) return `${city}, ${region}`;
    return venue?.location || city || region;
  }

  function longLocation(venue) {
    const city = venue?.city || '';
    const region = venue?.region || '';
    const full = REGIONS[region] || region;
    if (city && full) return `${city}, ${full}`;
    return venue?.location || city || full;
  }

  function ticketOffer(event) {
    const offers = Array.isArray(event.offers) ? event.offers : [];
    return offers.find(
      (offer) => offer.type === 'Tickets' && offer.status === 'available' && offer.url
    );
  }

  async function fetchArtist(name, appId) {
    const endpoint =
      `https://rest.bandsintown.com/artists/${encodeURIComponent(name)}` +
      `/events?app_id=${encodeURIComponent(appId)}&date=upcoming`;

    const response = await fetch(endpoint);
    if (!response.ok) throw new Error(`Bandsintown ${response.status}`);

    // A missing artist answers 200 with an empty string rather than [].
    const text = (await response.text()).trim();
    if (!text) return [];

    const data = JSON.parse(text);
    return Array.isArray(data) ? data : [];
  }

  function renderCard(template, event) {
    const card = template.content.firstElementChild.cloneNode(true);
    const time = card.querySelector('[data-field="date"]');
    const offer = ticketOffer(event);
    const tickets = card.querySelector('[data-field="tickets"]');
    const unavailable = card.querySelector('[data-field="unavailable"]');

    time.textContent = formatDate(event.datetime);
    time.setAttribute('datetime', event.datetime || '');
    card.querySelector('[data-field="badge"]').textContent = longLocation(event.venue);
    card.querySelector('[data-field="location"]').textContent = shortLocation(event.venue);
    card.querySelector('[data-field="venue"]').textContent = event.venue?.name || '';

    if (offer) {
      tickets.href = offer.url;
    } else {
      tickets.hidden = true;
      unavailable.hidden = false;
    }

    return card;
  }

  async function initTouring() {
    const root = document.querySelector(SECTION);
    if (!root) return;

    const status = root.querySelector('[data-touring-status]');
    const list = root.querySelector('[data-touring-list]');
    const template = document.querySelector('[data-touring-card]');
    const emptyMessage = root.dataset.emptyMessage || '';
    const appId = root.dataset.appId;
    const artists = (root.dataset.artists || '')
      .split(',')
      .map((name) => name.trim())
      .filter(Boolean);

    try {
      const results = await Promise.all(
        artists.map((name) => fetchArtist(name, appId))
      );

      // Co-headlined shows come back once per artist under the same event id.
      const unique = new Map();
      results.flat().forEach((event) => {
        if (event && event.id && !unique.has(event.id)) unique.set(event.id, event);
      });

      const events = [...unique.values()].sort((a, b) =>
        (a.datetime || '').localeCompare(b.datetime || '')
      );

      if (!events.length) {
        status.textContent = emptyMessage;
        return;
      }

      const fragment = document.createDocumentFragment();
      events.forEach((event) => fragment.append(renderCard(template, event)));

      list.append(fragment);
      list.hidden = false;
      status.hidden = true;
    } catch (error) {
      status.textContent = emptyMessage;
    }
  }

  initTouring();

  } catch(e) { console.error(e); }
})();
})();
